/**
 * open feature の公開ルート定義
 *
 * `lib/middleware/route-registry.ts` から static import される。
 *
 * `/open/**` は「お客様・社外の設計事務所が未認証で開くページ」の名前空間。
 * 2026-08-08: 正本に未登録だったため未認証で `/login` へ飛んでいた（本番現存）。
 *
 * **公開の根拠はページごとに異なる**（同じ理由でまとめない）:
 * - `/open`・`/open/g-plans`・`/open/g-plans/[id]`
 *   … 既存の公開API `/api/open/g-plans`（`is_published=true` のみ返す・以前から
 *      COMMON_PUBLIC_API_PATHS で未認証公開）の**画面化**。データは既に公開済みで露出は増えない
 * - `/open/plan-requests/[token]`
 *   … **URL の token 自体が認証境界**（`crypto.randomUUID()` 生成・
 *      `app/api/plan-requests/[id]/route.ts`）。token を知る社外の設計事務所だけが
 *      依頼情報（施主名・商品名・仕様・期限）を見て完了報告できる。
 *      上の「既に公開APIがあるから同じ」という根拠は**このページには当てはまらない**
 *      （Codex SO MEDIUM 指摘 2026-08-08）。書込先 `/api/open/plan-requests/report-complete`
 *      も以前から公開で、同じ token を検証している
 *
 * 前方一致で `/open` 配下すべてが公開になる。`app/open/**` にページ・API を足すときは
 * 「未認証で開いてよいか」を必ず判断すること（`tests/quality/` の機構ガードが存在を検査する）。
 *
 * Edge Runtime 制約:
 * - 純定数 export のみ（関数呼び出し・副作用なし）
 */

export const OPEN_PUBLIC_PATHS = {
  pages: ['/open'] as const,
  apis: [] as const,
} as const
